import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setBoolEditData } from './applicantDetailsSummaryActions';
import ApplicantDetailsSummary from './ApplicantDetailsSummary';
import {
    setEstaminatedPropertyMonthlyRent, setEstaminatedPropertyValue,
    setRequestedLoanAmount,
    setRequestedTimeSpan,
} from '../QuickQuote/quickQuoteActions';

function ApplicantDetailsSummaryContainer(props) {
    return (
        <ApplicantDetailsSummary
            setStep={props.setStep}
            setStepCompleted={props.setStepCompleted}
            setBoolEditData={props.setBoolEditData}
            editData={props.editData}
            maxLendAmount={props.maxLendAmount}
            estaminatedPropertyValue={props.estaminatedPropertyValue}
            estaminatedPropertyMonthlyRent={props.estaminatedPropertyMonthlyRent}
            requestedLoanAmount={props.requestedLoanAmount}
            requestedTimeSpan={props.requestedTimeSpan}
            setEstaminatedPropertyValue={props.setEstaminatedPropertyValue}
            setEstaminatedPropertyMonthlyRent={props.setEstaminatedPropertyMonthlyRent}
            setRequestedLoanAmount={props.setRequestedLoanAmount}
            setRequestedTimeSpan={props.setRequestedTimeSpan}
            mortgageType={props.mortgageType}
        />
    );
}

const mapStateToProps = state => ({
    editData: state.applicantDetailsSummaryReducer.editData,
    maxLendAmount: state.softCheckReducer.maxLendAmount,
    estaminatedPropertyValue: state.quickQuoteReducer.property.estaminatedPropertyValue,
    estaminatedPropertyMonthlyRent: state.quickQuoteReducer.property.estaminatedPropertyMonthlyRent,
    requestedLoanAmount: state.quickQuoteReducer.requestedLoanAmount,
    requestedTimeSpan: state.quickQuoteReducer.requestedTimeSpan,
    mortgageType: state.quickQuoteReducer.mortgageType,
});

const mapDispatchToProps = dispatch => ({
    setBoolEditData: (event) => {
        dispatch(setBoolEditData(event));
    },
    setEstaminatedPropertyValue: (event) => {
        dispatch(setEstaminatedPropertyValue(event));
    },
    setEstaminatedPropertyMonthlyRent: (event) => {
        dispatch(setEstaminatedPropertyMonthlyRent(event));
    },
    setRequestedLoanAmount: (event) => {
        dispatch(setRequestedLoanAmount(event));
    },
    setRequestedTimeSpan: (event) => {
        dispatch(setRequestedTimeSpan(event));
    },
});

ApplicantDetailsSummaryContainer.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setBoolEditData: PropTypes.func.isRequired,
    editData: PropTypes.bool.isRequired,
    maxLendAmount: PropTypes.object.isRequired,
    setEstaminatedPropertyValue: PropTypes.func.isRequired,
    setEstaminatedPropertyMonthlyRent: PropTypes.func.isRequired,
    setRequestedLoanAmount: PropTypes.func.isRequired,
    setRequestedTimeSpan: PropTypes.func.isRequired,
    estaminatedPropertyValue: PropTypes.object.isRequired,
    estaminatedPropertyMonthlyRent: PropTypes.object.isRequired,
    requestedLoanAmount: PropTypes.object.isRequired,
    requestedTimeSpan: PropTypes.number.isRequired,
    mortgageType: PropTypes.string.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ApplicantDetailsSummaryContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantDetailsSummary/ApplicantDetailsSummaryContainer.js